import { AxiosError } from 'axios'
import { Modal } from 'components/modal'
import { ModalEnum, RECURRING_PAYMENTS } from 'features/incidents/components/enums'
import { useEditProfile } from 'features/profile/api/editProfile'
import { useState } from 'react'
import { errorMessage, getUpperCase } from 'utils/function'

type RecurringProps = {
  openModal: { label: string; isOpen: boolean }
  setOpenModal: (value: { label: string; isOpen: boolean }) => void
  subscriptionStatus: boolean | undefined
  setNotification: (value: string) => void
  setRecurringStatus: (value: string) => void
}
const RecurringPayment = (props: RecurringProps) => {
  const { openModal, setOpenModal, subscriptionStatus, setRecurringStatus, setNotification } = props
  const [submitError, setSubmitError] = useState('')

  const { mutate } = useEditProfile()
  const recurringStatus = subscriptionStatus ? RECURRING_PAYMENTS.DISABLE : RECURRING_PAYMENTS.ENABLE

  return (
    <>
      <Modal
        active={openModal.label === ModalEnum.RECURRING_PAYMENT && openModal.isOpen}
        hideModal={() => {
          setOpenModal({ label: '', isOpen: false })
        }}
        title="Recurring Payment"
        onAccept={() => {
          const obj = {
            isAutoSubscriptionEnabled: !subscriptionStatus,
          }
          mutate(obj, {
            onSuccess: () => {
              setRecurringStatus(recurringStatus)
              setNotification(ModalEnum.RECURRING_PAYMENT)
              setOpenModal({ label: '', isOpen: false })
            },
            onError: error => {
              if (error instanceof AxiosError) {
                setSubmitError(errorMessage(error))
              }
            },
          })
        }}
        hasError={!!submitError}
        apiErrorText={submitError}
        description={`Are you sure you want to  ${recurringStatus}  recurring payments  ?`}
        acceptText={getUpperCase(recurringStatus, true)}
      />
    </>
  )
}

export default RecurringPayment
